import { Injectable } from '@angular/core';
import { Icon, IconItem } from '@sb/library/base';
import { EventLocationIcon } from '@sb/library/data-models';

@Injectable({
    providedIn: 'root'
})
export class CalendarEventIconManager {

    private _eventIconMap: Record<EventLocationIcon, IconItem | null> = {
        [EventLocationIcon.Car]: Icon.Common.DirectionsCar,
        [EventLocationIcon.Church]: Icon.Common.Church,
        [EventLocationIcon.HinduTemple]: Icon.Common.Om,
        [EventLocationIcon.Home]: Icon.Common.Home,
        [EventLocationIcon.Institution]: Icon.Common.University,
        [EventLocationIcon.Mosque]: Icon.Common.StarAndCrescent,
        [EventLocationIcon.None]: Icon.Common.Location,
        [EventLocationIcon.School]: Icon.Common.GraduationCap,
        [EventLocationIcon.Skype]: Icon.Brand.Skype,
        [EventLocationIcon.Studio]: Icon.Common.Apartment,
        [EventLocationIcon.Synagogue]: Icon.Common.StarOfDavid,
        [EventLocationIcon.Video]: Icon.Common.VideoCam,
    };

    GetEventIconName(icon: EventLocationIcon): IconItem | null {
        return this._eventIconMap[icon];
    }

}
